/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../../Shared/Loading'
import { Tabs, Tab } from 'react-bootstrap'
import { history } from '../../../_helpers'
import { tasksService } from '../../../_services/tasks.service'
import { unitTasksService } from '../../../_services/unitTasks.service'

import { Formik, FieldArray, Field } from 'formik'
import * as Yup from 'yup'

import Step1 from './Step1'
import Step2 from './Step2'

import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'

class Form extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: false,
      key: 'info',
      isModal: this.props.isModal,
      id: this.props.isModal ? this.props.id : this.props.match.params.id,
      taskType: this.props.isModal
        ? this.props.taskType
        : this.props.match.params.taskType,
      data: {
        categoryId: '',
        brandId: '',
        productId: '',
        quantity: '',
        items: [{ categoryId: '', brandId: '', productId: '', quantity: 0 }],
        newReserve: false
      },
      newReserve: this.props.newReserve || false
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    const { id } = this.state

    if (id) {
      this.setState({ loading: true })

      await tasksService
        .getById(id)
        .then(res => {
          let data = res.data
          data['categoryId'] = data.product.categoryId
          data['brandId'] = data.product.brandId
          // data["subQuantity"] = Math.round(data.quantity / data.product.conversionUnit)
          data['subQuantity'] = Number(
            (data.quantity / data.product.conversionUnit).toFixed(3)
          )

          if (data.items && data.items.length>0) {
            data.items.forEach(item => {
              item['categoryId'] = item.product.categoryId
              item['brandId'] = item.product.brandId
            })
          }
          console.log(data)
          this.setState({ data: data, loading: false, taskType: data.taskType })
        })
        .catch(error => {
          console.log(error)

          this.setState({ loading: false })
        })
    }
  }

  handleSubmit = (values, setSubmitting) => {
    // this.setState({ loading: true });
    values['taskType'] = this.state.taskType

    console.log(JSON.stringify(values))

    if (values.id) {
      tasksService
        .edit(values.id, JSON.stringify(values))
        .then(res => {
          toastr.success('ویرایش فرآیند تولید انجام شد')
          setSubmitting(false)

          this.props.onSubmit()
        })
        .catch(error => {
          setSubmitting(false)
        })
    } else {
      values['newReserve'] = this.props.newReserve
      console.log(values)
      tasksService
        .add(JSON.stringify(values))
        .then(res => {
          // console.log(res);

          this.setState({ loading: false, data: res.data, key: 'images' })
          toastr.success('ثبت فرآیند تولید انجام شد')

          setSubmitting(false)

          this.props.onSubmit()
        })
        .catch(error => {
          // console.log(error)
          setSubmitting(false)
        })
    }
  }

  handleError(error) {
    this.setState({ loading: false })
    // toastr.warning('مشکلی پیش آمد', error);
  }

  validateForm = errors => {
    if (Object.keys(errors).length > 0) {
      console.log(errors)
      let obj = errors
      let { categoryId, brandId, productId, quantity, items } = obj
      if (categoryId || brandId || productId || quantity) {
        this.setState({ key: 'info' })
      } else if (items) {
        this.setState({ key: 'materialsTab' })
      }
    }
  }

  render() {
    const { data, taskType, newReserve } = this.state

    const item = Yup.object().shape({
      categoryId: Yup.string()
        .trim()
        .nullable()
        .required('دسته بندی'),
      brandId: Yup.string()
        .trim()
        .nullable()
        .required('برند'),
      productId: Yup.string()
        .trim()
        .nullable()
        .required('محصول'),
      productOrderableQuantityWithoutReserves: Yup.number()
        .nullable()
        .test('', ' ', val => val > 0)
        .required(' '),
      orderableQuantity: Yup.number()
        .nullable()
        .test('', ' ', val => val > 0)
        .required(' '),
      productQuantity: Yup.number()
        .nullable()
        .test('', ' ', val => val > 0)
        .required(' ')
    })

    const ValidationSchema = Yup.object().shape({
      categoryId: Yup.string()
        .trim()
        .nullable()
        .required('دسته بندی'),
      brandId: Yup.string()
        .trim()
        .nullable()
        .required('برند'),
      productId: Yup.string()
        .trim()
        .nullable()
        .required('محصول'),
      quantity: Yup.string()
        .trim()
        .required('مقدار محصول'),
      items: Yup.array()
        .of(item)
        .min(
          newReserve == true ? 1 : taskType === 1 ? 3 : 1,
          'تمامی اطلاعات مواد اولیه'
        )
        .required('تمامی اطلاعات مواد اولیه')
    })
    return (
      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true)
          this.handleSubmit(values, setSubmitting)
        }}
        validationSchema={ValidationSchema}>
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm
          } = props
          return (
            <div>
              <div className="row" style={{ position: 'relative' }}>
                <form onSubmit={handleSubmit}>
                  <button
                    type="submit"
                    className={
                      'icon button submit-btn ' +
                      (isSubmitting ? 'isSubmitting' : '')
                    }
                    disabled={isSubmitting}
                    onClick={() =>
                      validateForm().then(errors => {
                        this.validateForm(errors)
                      })
                    }>
                    {isSubmitting ? (
                      <AiOutlineLoading className="mdi-spin" size="22px" />
                    ) : (
                      <AiOutlineSave size="22px" />
                    )}
                    {newReserve ? 'رزرو' : 'ذخیره'}
                  </button>
                  <Tabs
                    transition={false}
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}>
                    <Tab eventKey="info" title="اطلاعات فرآیند تولید">
                      <Step1
                        {...props}
                        taskType={this.state.taskType}
                        newReserve={this.state.newReserve}
                      />
                    </Tab>
                    <Tab eventKey="materialsTab" title="مواد اولیه">
                      <Step2
                        {...props}
                        taskType={this.state.taskType}
                        newReserve={this.state.newReserve}
                      />
                    </Tab>
                  </Tabs>
                  {/* {JSON.stringify(values)} */}
                </form>
              </div>
              {this.state.loading ? <Loading /> : ''}
            </div>
          )
        }}
      </Formik>
    )
  }
}

export default Form
